const REFERRAL_ROCK_COOKIE_NAME = 'RR_WCID=';

/**
 * Updates referral rock with the user's info based on a cookie that may be
 *   attached to the document.
 *
 * @param payload.firstname
 *        Referral First Name is HIGHLY RECOMMENDED.
 *        Alternatively, replace with fullname and we will parse the name.
 *        Used for referral communications with |*DONALD*| merge tag.
 * @param payload.email
 *        Referral Email is HIGHLY RECOMMENDED.
 *        Used to communicate with referrals through the Referral Rock platform.
 *        One of two parameters that can be used to positively ID referrals later and protect against fraud.
 *        One is REQUIRED for referral updates. Alternatively, use externalidentifier.
 *        REQUIRED for referral rewards and program emails to referrals.
 * @param payload.externalidentifier,
 *        An ExternalID that is unique to the referral is RECOMMENDED. Can be a Customer#, Account#, UUID, etc.
 *        One of two parameters that can be used to positively ID referrals later and protect against fraud.
 *        One is REQUIRED for referral updates. Alternatively, use email.
 * @param payload.amount "999",
 *        RECOMMENDED. Generally a purchase amount, subscription length, or other # tied to a referral action.
 *        Allows better ROI analysis of your referral program.
 *        REQUIRED for %-based member or referral rewards.
 * @param payload.referralcode
 *        Can set to a member referral code.  Member referral code overrides any cookie.  You can set to "TESTID" for testing.
 * @param payload.conversionstatus "PROGRAMRULE",
 *        Default value is  "PROGRAMRULE" configurable on your program to automatically approve or leave as pending
 *        Other Values "PENDING", "QUALIFIED", "APPROVED", "DENIED"
 * @param payload.fullname
 * @param payload.lastname
 * @param payload.phone
 * @param payload.note
 * @param payload.publicnote
 * @param payload.preferredcontact
 * @param payload.customoption1name
 * @param payload.customoption2name
 * @param payload.customtext1name
 * @param payload.customtext2name
 * @param payload.customtext3name
 * @param payload.customoption1value
 * @param payload.customoption2value
 * @param payload.customtext1value
 * @param payload.customtext2value
 * @param payload.customtext3value
 * @param payload.externalidentifier_param_name
 * @param payload.email_param_name
 * @param payload.amount_param_name
 * @param payload.firstname_param_name
 * @param payload.lastname_param_name
 * @param payload.note_param_name
 * @param payload.fullname_param_name
 */
export const referralRockConversion = (payload) => {
  // Only perform this event if the referral rock pixel is installed
  if (window.rrSpace && typeof window.rrSpace.executeEvent === 'function') {
    const testMode = process.env.DEPLOY_ENV !== 'prod';
    if (testMode || document.cookie.includes(REFERRAL_ROCK_COOKIE_NAME)) {
      const eventPayload = {
        debug: 'false',
        parameters: {
          ...payload,
          ...(testMode ? { referralcode: 'TestID' } : {})
        }
      };
      window.rrSpace.executeEvent('conversion', eventPayload);
    }
  }
};



// WEBPACK FOOTER //
// ./src/modules/referral-rock.js